module.exports = __webpack_public_path__ + "img/559aee0ca0a54666d18fcf843e797eed.png";